export function isGroup(mixed: any|string) {
    // a group of nodes, or string as label: this is magic, and not good
    if (typeof mixed === 'string') {
        return ['OrGroup', 'AndGroup'].indexOf(mixed) > -1
    }
    return ['OrGroup', 'AndGroup'].indexOf(mixed.label) > -1
}
